export const environment = {
  environment: 'development',
  // Keycloak
  keycloakUrl: 'https://auth.test123.nl',
  keycloakRealm: 'wander-and-wonder',
  keycloakClientId: 'stichting-wijkcollectie',
  // API
  apiUrl: 'https://swc-cms-api.test123.nl',
  // apiUrl: 'http://swc-cms-api.docker:8080'
  // apiUrl: 'https://api-cms.wijkcollectie.nl'
};
